import { render, staticRenderFns } from "./setups.vue?vue&type=template&id=2520c67f&"
import script from "./setups.vue?vue&type=script&lang=js&"
export * from "./setups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports